export default {
  title: 'Rename offer',
  subtitle: 'Enter a new name for your offer (maximum 40 characters)',
  toasts: {
    success: 'Offer renamed successfully',
    error: 'Failed to rename offer',
  },
  buttons: {
    rename: 'Rename',
  },
  form: {
    title: {
      label: 'Offer name',
      placeholder: 'Enter Offer Name',
    },
  },
};
